import TurnoverManagement from './TurnoverManagement.vue'
export default TurnoverManagement



// WEBPACK FOOTER //
// ./src/pages/TurnoverManagement/index.js